import React, { useState, useEffect } from 'react'

const Navbar = () => {
	const [scrolled, setScrolled] = useState(false)
	const [menuOpen, setMenuOpen] = useState(false)

	useEffect(() => {
		const handleScroll = () => setScrolled(window.scrollY > 50)
		window.addEventListener('scroll', handleScroll)
		return () => window.removeEventListener('scroll', handleScroll)
	}, [])

	const links = [
		{ href: '#projects', label: 'Work' },
		{ href: '#about', label: 'About' },
		{ href: '#toolkit', label: 'Skills' },
		{ href: '#ai', label: 'AI' },
		{ href: '#contact', label: 'Contact' },
	]

	return (
		<nav
			className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
				scrolled
					? 'py-3 bg-[#030712]/90 backdrop-blur-md border-b border-white/10'
					: 'py-5'
			}`}>
			<div className='max-w-6xl mx-auto px-6 lg:px-12 flex items-center justify-between'>
				<a
					href='#'
					className='text-xl font-bold bg-gradient-to-r from-blue-400 to-cyan-400 bg-clip-text text-transparent tracking-tight'>
					ZB.
				</a>

				{/* Desktop nav */}
				<div className='hidden md:flex items-center gap-8'>
					{links.map(({ href, label }) => (
						<a
							key={label}
							href={href}
							className='text-gray-400 hover:text-white transition-colors duration-300 text-sm font-medium'>
							{label}
						</a>
					))}
					<a
						href='mailto:z4zakarya@gmail.com'
						className='px-5 py-2 border border-blue-500/50 text-blue-400 text-sm font-medium rounded-full hover:bg-blue-500/10 hover:border-blue-400 transition-all duration-300'>
						Hire Me
					</a>
				</div>

				{/* Mobile menu button */}
				<button
					className='md:hidden text-gray-400 hover:text-white transition-colors'
					onClick={() => setMenuOpen(!menuOpen)}>
					<i className={`fas ${menuOpen ? 'fa-times' : 'fa-bars'} text-xl`} />
				</button>
			</div>

			{/* Mobile menu */}
			{menuOpen && (
				<div className='md:hidden bg-[#030712]/95 backdrop-blur-md border-t border-white/10 px-6 py-6 flex flex-col gap-4'>
					{links.map(({ href, label }) => (
						<a
							key={label}
							href={href}
							onClick={() => setMenuOpen(false)}
							className='text-gray-400 hover:text-white transition-colors duration-300 text-base font-medium'>
							{label}
						</a>
					))}
					<a
						href='mailto:z4zakarya@gmail.com'
						className='text-blue-400 text-base font-medium'>
						Hire Me
					</a>
				</div>
			)}
		</nav>
	)
}

export default Navbar
